import { BaseApiV2, Methods, QueryWrapper } from "@newview/infrastructure";

export class CalcPythonApi extends BaseApiV2 {
    public get ProxyName(): any {
        return 'CalcPythonApi';
    }

    public get ControllerName(): any {
        return 'calc';
    }

    /**
     * 运行Sql Action
     * @param programkey 
     * @param projectid 
     * @param childsysid 
     * @param devprod 
     * @param params 
     * @returns 
     */
    public async debugSqlAction(programkey, projectid, childsysid, devprod, params) {
        return this.send({ programkey, projectid, childsysid, devprod, params: params == undefined ? {} : params }, 'run_action', Methods.POST)
    }

    /**
     * 调试Action
     * @param enginerringid 工程Id
     * @param moduleid 模块Id
     * @param programkey 程序Key
     * @param content 程序内容
     * @param projectid 项目Id
     * @param childsysid 子系统Id
     * @param devprod 环境
     * @param params 参数
     * @returns 
     */
    public async debugAction(enginerringid, moduleid, programkey, content, projectid, childsysid, devprod, params) {
        const apiResult = await this.writeAction(enginerringid, moduleid, programkey, content, true);
        if (apiResult.code == 200 && apiResult.data) {
            return this.send({
                enginerringid,
                moduleid,
                programkey,
                content,
                projectid,
                childsysid,
                devprod,
                params: params == undefined ? {} : params
            }, "debug_action", Methods.POST);
        } else {
            return apiResult;
        }
    }

    /**
     * 写入 Action
     * @param enginerringid 工程Id
     * @param moduleid 模块Id
     * @param programkey 程序Key
     * @param content 程序内容
     * @param debug 调试
     * @returns 
     */
    public writeAction(enginerringid, moduleid, programkey, content, debug) {
        return this.send({
            enginerringid,
            moduleid,
            programkey,
            content,
            debug
        }, "write_action", Methods.POST)
    }

    /**
     * 发布Action
     * @param pyExecUrl 
     * @param enginerringid 
     * @param moduleid 
     * @param programkey 
     * @param content 
     * @returns 
     */
    public publishAction(pyExecUrl, enginerringid, moduleid, programkey, content) {
        return this.sendUrl(
            `${pyExecUrl}/api/v1/${this.ControllerName}/write_action`, {
            enginerringid,
            moduleid,
            programkey,
            content,
            debug: false
        }, Methods.POST)
    }
}